import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/InventorySettings'


// create the fragment store

export class InventorySettingsStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "InventorySettingsStore",
			variables: true,
			
		})
	}
}
